import type { PreviewContextMenuState } from './types'
import { Edit, Send, Image } from 'lucide-react'
import { useEffect } from 'react'

interface PreviewContextMenuProps {
  state: PreviewContextMenuState | null;
  onClose: () => void;
  onSendRemix: () => void;
  onRemixCurrent: () => void;
  onOpenFramePicker: () => void;
  canSendToNext: boolean;
  canRemixCurrent: boolean;
  canPickFrame: boolean;
}

const PreviewContextMenu: React.FC<PreviewContextMenuProps> = ({
  state,
  onClose,
  onSendRemix,
  onRemixCurrent,
  onOpenFramePicker,
  canSendToNext,
  canRemixCurrent,
  canPickFrame,
}) => {
  useEffect(() => {
    if (!state) return
    const handler = (e: MouseEvent) => {
      e.stopPropagation()
      onClose()
    }
    window.addEventListener('click', handler, { capture: true })
    return () => window.removeEventListener('click', handler, { capture: true } as any)
  }, [state, onClose])

  if (!state) return null
  const { top, left } = state.anchorPosition
  return (
    <div className="fixed inset-0 z-50 pointer-events-none">
      <div
        className="absolute pointer-events-auto min-w-56 rounded-md border bg-popover text-popover-foreground shadow-md"
        style={{ top, left }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="w-full flex items-center gap-2 p-2 text-sm hover:bg-muted disabled:opacity-50 disabled:pointer-events-none"
          onClick={() => onRemixCurrent()}
          disabled={!canRemixCurrent}
        >
          <Edit className="size-4" /> 在本单元 Remix
        </button>
        <button
          className="w-full flex items-center gap-2 p-2 text-sm hover:bg-muted disabled:opacity-50 disabled:pointer-events-none"
          onClick={() => onSendRemix()}
          disabled={!canSendToNext}
        >
          <Send className="size-4" /> 将视频 ID 发送至下一个单元进行 Remix
        </button>
        <button
          className="w-full flex items-center gap-2 p-2 text-sm hover:bg-muted disabled:opacity-50 disabled:pointer-events-none"
          onClick={() => onOpenFramePicker()}
          disabled={!canPickFrame}
        >
          <Image className="size-4" /> 选择一帧发送至下个视频作为参考图
        </button>
      </div>
    </div>
  )
}

export default PreviewContextMenu;
